module.exports = __webpack_public_path__ + "img/achol.fa2fdba9.png";